// Our Company correction (SAD-548, ID-07): which company profile the tenant
// is designates "us". Reassigning it never rewrites history — every
// relationship, rate and attribution already recorded stays with the company
// that earned it; only the designation itself is append-only audited
// (OwnCompanyDesignationProto). Writes are gated server-side on
// requireCompanySettingsAuthority — mirrored client-side by
// useTenantAreas().canManageCompanySettings.
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { deliveryClient } from '../../../lib/connect/clients';
import { entityErrorMessage } from '../_shared/lib/entityErrorMessage';
const OWN_COMPANY_DESIGNATIONS_KEY = 'own company designations';
// Gated the same as the write; a caller without the authority gets a quiet
// read failure from the server, which the caller handles via `isError`
// rather than a thrown toast.
export function useOwnCompanyDesignations() {
    return useQuery({
        queryKey: [
            OWN_COMPANY_DESIGNATIONS_KEY
        ],
        queryFn: async ()=>{
            const resp = await deliveryClient.listOwnCompanyDesignations({
                limit: 20
            });
            return resp.designations;
        },
        staleTime: 15000
    });
}
export function useSetOwnCompany() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (req)=>{
            const resp = await deliveryClient.setOwnCompanyProfile({
                companyProfileId: req.companyProfileId,
                reason: req.reason ?? ''
            });
            return resp.profile;
        },
        onSuccess: ()=>{
            // The badge lives on the company profile list/detail; the prime-autofill
            // resolution caches under 'ownCompanyProfile' (see companyProfileHooks'
            // extraInvalidateKeys) — both must move without a manual reload.
            qc.invalidateQueries({
                queryKey: [
                    'company profile'
                ]
            });
            qc.invalidateQueries({
                queryKey: [
                    'ownCompanyProfile'
                ]
            });
            qc.invalidateQueries({
                queryKey: [
                    OWN_COMPANY_DESIGNATIONS_KEY
                ]
            });
            toast.success('Our Company updated');
        },
        onError: (err)=>{
            toast.error(entityErrorMessage(err, 'save', 'Our Company designation'));
        }
    });
}
